module.exports = __webpack_public_path__ + "static/media/bears_donut.3f168bf5.jpg";